/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import { interpret } from 'xstate-v4'
import { MapboxSearchAPI } from '~/apps/geo/MapboxSearchAPI'
import { rootContainer } from '~/container'
import sentryCapture from '~/utility/sentryCapture'
import FetchLocationCampsiteSuggestions from './campsites-search/location/infrastructure/FetchLocationCampsiteSuggestions'
import FetchLocationHierarchySuggestions from './campsites-search/location/infrastructure/FetchLocationHierarchySuggestions'
import FetchLocationRecentSearchSuggestions from './campsites-search/location/infrastructure/FetchLocationRecentSearchSuggestions'
import { returnSuggestionsMachine } from './campsites-search/location/machine/suggestionsMachine'

export function getSuggestionsMachine(langCode: string) {
  const { $sessionId } = useNuxtApp()
  const mapboxSearchAPI = new MapboxSearchAPI(langCode, $sessionId)

  return interpret(
    returnSuggestionsMachine().withConfig({
      services: {
        getHierarchySuggestions: ({ input }) =>
          new FetchLocationHierarchySuggestions().fetch(input, langCode),
        getCampsiteSuggestions: ({ input }) =>
          new FetchLocationCampsiteSuggestions().fetch(input, langCode),
        getRecentSearchSuggestions: ({ input }) =>
          new FetchLocationRecentSearchSuggestions().fetch(input, langCode),
        getCustomGeoSuggestions: ({ input }) => mapboxSearchAPI.get(input),
        getPointForCustomGeoSuggestion: (_, evt) => {
          if (evt.type === 'LOAD_POINT_FOR_CUSTOM') {
            return mapboxSearchAPI.getPointForSuggestion(evt.mapboxId)
          } else {
            throw new Error(
              'getPointForCustomGeoSuggestion called by non LOAD_POINT_FOR_CUSTOM event',
            )
          }
        },
      },
      actions: {
        logError: (_, event: any) => {
          event.data.name = 'SuggestionsMachine ' + event.type + ' error'
          sentryCapture(event.data, rootContainer)
        },
      },
    }),
  ).start()
}
